<template>
    <apexchart :options="chartOptions" :series="series" type="bar"/>
</template>

<script>
    export default {
        name: "WidgetChart1",
        data() {
            return {
                chartOptions: {
                    chart: {
                        id: 'vuechart-example',
                        toolbar: {
                            show: false
                        },
                    },
                    xaxis: {
                        //categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
                        categories: ["01.04", "02.04", "03.04", "04.04", "05.04", "06.04", "07.04"]
                    },
                    title: {
                        text: "Кол-во принятых заявок по дням"
                    },
                },
                series: [{
                    name: 'series-1',
                    data: [10, 2, 1, 5, 7, 6, 4]
                }]


            }
        },
    }
</script>

<style scoped>

</style>